import Select from 'react-select'
import React, { useEffect, useRef, useState } from 'react'
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CButton,
  CNavLink,
  CFormTextarea,
  CSpinner,
  CAvatar,
  CImage,
  CAccordion,
  CAccordionBody,
  CAccordionItem,
  CAccordionHeader,
  CFormLabel,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react'

import PatientPersonalHistory from './PatientPersonalHistory'
import PatientInfoDisplay from './PatientInfoDisplay'
import PatientVitals from './PatientVitals'
import PatientMedication from './PatientMedication'
import PatientImaging from './PatientImaging'
import ShowDemographics from './Demographics'

import PatientHistoryForm from './PatientHistoryForm'
import PatientInternalNotes from './PatientInternalNotes'
import Addendum from './Addendum'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'

import DiagnosisAssessment from './DiagnosisAssessment'
import PatientAllergies from './PatientAllergies'
import PatientPsychiatryNote from './PatientPsychiatryNote'
import PatientFinalNote from './PatientFinalNote'
import PatientLabs from './PatientLabs'
import Summary from './Summary'
import { useDispatch, useSelector } from 'react-redux'
import Note from './Note'
import PatientMedications from '../../services/general/patientMedicationData.api'
import PatientImagingsCRUD from '../../services/general/patientImagingData'
import ImagingInformation from '../../services/general/ImagingAPI.api'
import ModifyPatientHistory from '../../services/general/modifyPatientHistory.api'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api'
import PatientOrder from './PatientOrder'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
// import ViewCallCenter from './ViewCallCenter';
import MedicineCRUD from '../../services/general/Medication.api'
import { TuneOutlined } from '@mui/icons-material'
import { motion } from 'framer-motion'
import { Check, CheckCircle, EllipsisVertical, Printer, Save } from 'lucide-react'
import PatientDataCRUD from '../../services/general/patientNoteData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import PatientFloatingButton from './PatientFloatingButton'
import { usePDF } from 'react-to-pdf'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Reports from './Reports'
import Loader from '../../components/shared/Loader'
import HPIQuestions from './HPIQuestions'
import Provider from './Provider'
import DetailNote from './DetailNote'
import SuperBill from './SuperBill'
import { Data } from '@react-google-maps/api'
import AddDiagnosisModal from './AddDiagnosisModal'
import PatientNoteViewInModal from './PatientNoteViewInModal'
import PastOrder from './PastOrder'
import SaveExtra from '../../services/general/saveExtraData.api'
import PatientPastNote from './PatientPastNote'
import FacilityCRUD from '../../services/general/getFacilityData.api'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import { sendUpdate } from '../../components/shared/StorageSync'
import { getAllAppointments, getAllAppointmentsDetails, getAppointmentDataID } from '../../components/shared/appointmentFilterData'
import PatientAppointmentDetails from '../../services/general/appointmentData.api'
import PatientPhysicalExaminationData from '../../services/general/physicalExaminationData.api'
// import SavePatients from '../../services/general/savePatientinformation.api'
import AddPatientDiagnosisModal from './AddPatientDiagnosisModel'
import SavePatients from '../../services/general/savePatientinformation.api'
import PatientPastNoteAdmin from './PatientPastNotesAdmin'
import { usePatientStatus } from '../../hooks/usecheckForUpdate'
import { checkIfDataAvailableData, convertDate } from '../../utils/checkForUpdateUtils'

const APP_THEME_STORAGE_KEY = 'provio_theme'

const readPatientInfoTheme = () => document.documentElement.getAttribute('data-theme') || document.body.getAttribute('data-theme') || localStorage.getItem(APP_THEME_STORAGE_KEY) || 'dark'

const PatientInfoSecond = ({
  // saveDiagnosisData,
  // creatingNewNote = false,
  // setRowClicked,
  // patientID,
  // patientData,
  showBreadcrumbs = false,
  // dataCallType,
  // setDataId,
  // noteID,
  breadCrumbText = 'Appointment',
  breadCrumbHref = '/home/appointment',
  // setEditDataId,
  // setDataCallType,
  // noteStatus,
  showAllData = true,
  showNoteView = false,
  //   handleAddNoteId,
  setAppointmentDetails = false,
  isAllotedToProvider = false,
}) => {
  // parent states
  const [appointments, setAppointments] = useState([])
  const [allAppointment, setAllAppointment] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [setDataId, setEditDataId] = useState(null)
  const [dataCallType, setDataCallType] = useState(null)
  const [noteID, setNoteID] = useState(null)
  const [rowClicked, setRowClicked] = useState(null)
  const [noteStatus, setNoteStatus] = useState('New Note')
  const [patientData, setPatientData] = useState('')
  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [patientID, setPatientID] = useState(-1)
  const [patientAppointmentID, setPatientAppointmentID] = useState(null)
  const [appointment, setAppointment] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [patientAppointment, setPatientAppointment] = useState([])
  const [theme, setTheme] = useState(readPatientInfoTheme)
  const { updatePatientData } = usePatientStatus()

  const [creatingNewNote, setCreatingNewNote] = useState(false)
  const hasValidPatientContext = patientID !== null && patientID !== undefined && patientID !== -1 && patientID !== ''
  const hasValidNoteContext = hasValidPatientContext && noteID !== null && noteID !== undefined && noteID !== -1
  const sectionLoadStateRef = useRef({})
  const hasRenderedDiagnosisRefreshRef = useRef(false)

  const ensureSectionLoaded = async (key, loader) => {
    const currentState = sectionLoadStateRef.current[key]

    if (currentState === 'loaded') {
      return
    }

    if (currentState && typeof currentState.then === 'function') {
      return currentState
    }

    const loadPromise = Promise.resolve(loader())
      .then((result) => {
        sectionLoadStateRef.current[key] = 'loaded'
        return result
      })
      .catch((error) => {
        delete sectionLoadStateRef.current[key]
        throw error
      })

    sectionLoadStateRef.current[key] = loadPromise
    return loadPromise
  }

  useEffect(() => {
    const syncTheme = (event) => {
      setTheme(event?.detail?.theme || readPatientInfoTheme())
    }

    window.addEventListener('provio-theme-change', syncTheme)
    window.addEventListener('storage', syncTheme)

    return () => {
      window.removeEventListener('provio-theme-change', syncTheme)
      window.removeEventListener('storage', syncTheme)
    }
  }, [])

  const safeParser = (data) => {
    try {
      return JSON.parse(data)
    } catch (e) {
      return data
    }
  }



  console.log("appoinmennts", appointments)
  useEffect(() => {
    const setEditDataIdLocal = safeParser(localStorage.getItem('setEditDataIdLocal'))
    const setDataCallTypeLocal = safeParser(localStorage.getItem('setDataCallTypeLocal'))
    const setNoteStatusLocal = safeParser(localStorage.getItem('setNoteStatusLocal'))
    const setPatientModalVisibleLocal = safeParser(localStorage.getItem('setPatientModalVisibleLocal'))
    const setNoteIDLocal = safeParser(localStorage.getItem('setNoteIDLocal'))
    const setPatientIDClickedLocal = safeParser(localStorage.getItem('setPatientIDClickedLocal'))
    const setRowClickedLocal = safeParser(localStorage.getItem('setRowClickedLocal'))
    const setPatientAppointmentIDLocal = safeParser(localStorage.getItem('setPatientAppointmentIDLocal'))
    const setCreatingNewNoteLocal = localStorage.getItem('setCreatingNewNote') === 'true' ? true : localStorage.getItem('setCreatingNewNote') === 'false' ? false : null

    console.log("setPatientAppointmentIDLocal", setPatientAppointmentIDLocal)
    if (setCreatingNewNoteLocal !== null && setCreatingNewNoteLocal !== undefined) {
      setCreatingNewNote(setCreatingNewNoteLocal)
    }

    if (setEditDataIdLocal !== null && setEditDataIdLocal !== undefined) {
      setEditDataId(setEditDataIdLocal)
    }
    if (setDataCallTypeLocal !== null && setDataCallTypeLocal !== undefined) {
      setDataCallType(setDataCallTypeLocal)
    }
    if (setNoteStatusLocal !== null && setNoteStatusLocal !== undefined) {
      setNoteStatus(setNoteStatusLocal)
    }
    if (setNoteIDLocal !== null && setNoteIDLocal !== undefined) {
      setNoteID(setNoteIDLocal)
    }
    if (setPatientIDClickedLocal !== null && setPatientIDClickedLocal !== undefined) {
      setPatientIDClicked(setPatientIDClickedLocal)
    }
    // if (setRowClickedLocal !== null && setRowClickedLocal !== undefined) {setRowClicked(setRowClickedLocal);setPatientData(setRowClickedLocal)}
    if (setPatientIDClickedLocal !== null && setPatientIDClickedLocal !== undefined) {
      setPatientID(setRowClickedLocal?.PatientID || setPatientIDClickedLocal)
    }
    if (setPatientAppointmentIDLocal !== null && setPatientAppointmentIDLocal !== undefined) {
      setPatientAppointmentID(setPatientAppointmentIDLocal)
    }

    localStorage.removeItem('setEditDataIdLocal')
    localStorage.removeItem('setDataCallTypeLocal')
    localStorage.removeItem('setNoteStatusLocal')
    localStorage.removeItem('setPatientModalVisibleLocal')
    localStorage.removeItem('setNoteIDLocal')
    localStorage.removeItem('setPatientIDClickedLocal')
    localStorage.removeItem('setRowClickedLocal')
    localStorage.removeItem('setPatientAppointmentIDLocal')
    localStorage.removeItem('setPatientIDLocal')
    localStorage.removeItem('setCreatingNewNote')
  }, [])

  //   adding parent states
  const handleAllAppointmentsData = async (type, byDate) => {
    const [appointmentData, appointmentDetails] = await Promise.all([getAllAppointments(type, byDate), getAllAppointmentsDetails(type, byDate)])

    setAllAppointment(appointmentData)
    setAppointments(appointmentDetails)
    return appointmentDetails || []
  }

  const getAppointmentData = async () => {
    setIsPageLoading(true)
    try {
      const flatAppointments = await handleAllAppointmentsData('GET')
      setAppointment(flatAppointments || [])
      return flatAppointments
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }
  const setPatientDataFromAPi = async () => {
    if (patientID !== -1) {
      let patientData = await SavePatients('GetAll', '', '', '')
      patientData = JSON.parse(patientData.d).Data
      let patientDataFind = patientData.find((item) => item.PatientID === patientID)
      setPatientData(patientDataFind)
    }
  }


  useEffect(() => {
    setPatientDataFromAPi()
  }, [patientID])

  const patientDataFn = async () => {
    setIsPageLoading(true)
    try {
      const refreshedAppointments = await getAppointmentData()
      setAppointment(refreshedAppointments || [])
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }
  const handleAddNoteId = async (noteID, appointmentDetails) => {
    try {
      setIsPageLoading(true)

      const groupedData = []

      const selectedAppointments = appointmentDetails.filter((item) => item?.data?.AppointmentID === patientAppointmentID)
      if (selectedAppointments.length === 0) {
        cosnole.error('appointment note found')
      }

      const appointment = selectedAppointments[0]

      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)

      let appointmentFilterData = latestData.map((item) => {
        if (item.data.AppointmentID === patientAppointmentID) {
          return {
            ...item,
            data: {
              ...item.data,
              NoteID: noteID,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)

      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value, JSON.stringify(groupedData))
      } else {
        toast.error('Appointment ID note found', toastConfig)
      }
      // await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      await patientDataFn()
      await setPatientDataFromAPi()

      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save Note Id', toastConfig)
      console.log('error', error)
    } finally {
      setIsPageLoading(false)
      setPatientAppointment([])
    }
  }
  const patientSelectedFacility = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)

      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) { }
  }

  const saveDiagnosisData = async (customData) => {
    let a = {}
    let facility = await patientSelectedFacility(customData)

    try {
      a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
      a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
      a['Room'] = customData?.Room?.toString() || roomNumber.toString()
    } catch (e) {
      a['FacilityID'] = ''
      a['FacilityName'] = ''
      a['Room'] = -1
    }

    // let allDiagnosis = allSelectedDiagnosis.map(obj => { return obj.label }).join(",");

    let allDiagnosis = customData?.Diagnosis || ''

    let insurances = addedInsurances.map((ins) => ({
      InsuranceID: ins?.ID,
    }))

    let savePatientInfo
    if (patientID && patientID !== '') {
      // savePatientInfo = SavePatients('Update', JSON.stringify(customData ? customData : childformData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
    }

    // await savePatientInfo;

    await patientDataFn()
    await setPatientDataFromAPi()

    // resetStates()
  }

  const [activeTab, setActiveTab] = useState(0)
  const [addDiagnosisModalVisible, setAddDiagnosisModalVisible] = useState(false)
  const [historyPersonalHistoryActiveTab, setHistoryPersonalHistoryActiveTab] = useState('pmhx')
  const [loading, setLoading] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [patientDiagnosis, setPatientDiagnosis] = useState([])
  const [allergiesList, setAllergiesList] = useState([])
  const [Notes, setNotes] = useState([])
  const [vitalsList, setVitalsList] = useState([])
  const [diagnosisAddedPinger, setDiagnosisAddedPinger] = useState(false)
  const [allHistory, setAllHistory] = useState([])
  const [allLabs, setAllLabs] = useState([])
  const [reRender, setReRender] = useState(false)
  const [patientOrders, setPatientOrders] = useState([])
  const [masterMedications, setMasterMedications] = useState([])
  const [newImagingAdded, setNewImagingAdded] = useState(false)
  const [newmedsAdded, setNewmedsAdded] = useState(false)
  const [newLabsAdded, setNewLabsAdded] = useState(false)
  const [isPatientPageLoading, setIsPatientPageLoading] = useState(false)
  const [selectedRisks, setSelectedRisks] = useState({})
  const [selectedDifferentialDiagnosis, setSelectedDifferentialDiagnosis] = useState({})
  const [MasterDiagnosisData, setMasterDiagnosisData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [showComment, setShowComment] = useState(false)
  const [showSaveModel, setShowSaveModel] = useState(false)
  const [submitLoader, setSubmitLoader] = useState(false)
  const [histories, setHistories] = useState({
    pmhx: [],
    pshx: [],
    fh: [],
    sh: [],
  })
  const [patientTreatments, setPatientTreatments] = useState(null)
  const patientTreatmentsRef = useRef([])
  const [diagnosisCode, setDiagnosisCodes] = useState({})
  const [noteView, setNoteView] = useState(false)
  const [signModel, setSignModel] = useState(false)
  const [appoinmentDate, setAppointmentData] = useState()
  const [selectedFacility, setSelectedFacility] = useState({})
  const [facilities, setFacilities] = useState([])
  const [showOrderPopUp, setShowOrderPopUp] = useState(true)
  const [addendum, setAddendum] = useState([])
  const [pastOrders, setPastOrders] = useState([])
  const [showOrderPopUpYN, setShowOrderPopUpYN] = useState(false)
  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '0',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
  })

  const resetStates = () => {
    setChildFormData({
      FirstName: '',
      MiddleName: '',
      LastName: '',
      DOB: '',
      Gender: '',
      Age: '0',
      PhoneNumber: '',
      EmergencyName: '',
      EmergencyPhone: '',
      Address: '',
      State: '',
      City: '',
      ZipCode: '',
      Country: '',
      insurance: '',
    })
    setRoomNumber('')
    setSelectedFacility({})
    setAddedInsurances([])
    setInsuranceList([])
    setSelectedDetails({})
    setAllSelectedDiagnosis([])
    setModalVisible(false)
  }

  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' })
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const noteStructureRef = useRef({})

  const [medicationList, setMedicationList] = useState([])

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
      }))
      setFacilities(formattedData)
    } catch (e) { }
  }

  const patientSelected = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) { }
  }

  const updatePatientDiagnosis = async (patientID, diagnosis) => {
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
    patientDiagnosis = patientDiagnosis
      .split(',')
      .filter((diagnosis) => diagnosis.trim().length > 0)
      .map((diagnosis) => diagnosis.trim())

    diagnosis = diagnosis.split(',')

    let arr = [...patientDiagnosis, ...diagnosis]
    let mergedArr = [...new Set(arr)]
    let newDiagnosis = mergedArr.join(',')

    let patientAllData = await patientSelected(patientData)
    await ModifyPatientMap('UPDATE', patientID, newDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
  }

  const editPatientDiagnosis = async (patientID, oldDiagnosis, newDiagnosis) => {
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
      .split(',')
      .map((diagnosis) => diagnosis.trim())
      .filter((diagnosis) => diagnosis.length > 0)

    let updatedDiagnosis = patientDiagnosis.map((diagnosis) => (diagnosis === oldDiagnosis ? newDiagnosis : diagnosis))

    let finalDiagnosis = [...new Set(updatedDiagnosis)].join(',')

    let patientAllData = await patientSelected(patientData)

    await ModifyPatientMap('UPDATE', patientID, finalDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
  }

  const deletePatientDiagnosis = async (patientID, diagnosisToDelete) => {
    if (diagnosisData && diagnosisData?.length === 0) {
      toast.error('We couldn’t find the diagnosis. Please refresh the page and try again.', toastConfig)
    }
    let patientDiagnosis = diagnosisData[0].Diagnosis.replace(/\"/g, '')
      .split(',')
      .map((diagnosis) => diagnosis.trim())
      .filter((diagnosis) => diagnosis.length > 0)

    setRowClicked((p) => {
      const diagnosisArray = p?.Diagnosis ? p?.Diagnosis?.split(',').map((item) => item.trim()) : []

      const updatedDiagnosisArray = diagnosisArray.filter((item) => item !== diagnosisToDelete)

      return {
        ...p,
        Diagnosis: updatedDiagnosisArray.join(', '),
      }
    })

    let updatedDiagnosis = patientDiagnosis.filter((diagnosis) => diagnosis !== diagnosisToDelete)
    if (noteStructureRef.current && noteStructureRef.current.metadata && noteStructureRef.current.metadata.diagnosisIds) {
      let response = await GetDiagnosisData('')
      response = JSON.parse(response.d)?.Data

      const filteredNoteDiagnosis = response?.find((id) => id.Name == diagnosisToDelete)
      noteStructureRef.current.metadata.diagnosisIds = noteStructureRef.current.metadata.diagnosisIds.filter((id) => id !== filteredNoteDiagnosis?.id)
      await PatientNoteDataCRUD('UPDATE', patientID.toString(), setDataId?.toString(), JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
    }

    let finalDiagnosis = updatedDiagnosis.join(',')
    let patientAllData = await patientSelected(patientData)

    await ModifyPatientMap('UPDATE', patientID, finalDiagnosis, patientAllData?.value)
    await getPatientDiagnosis()
    setDiagnosisAddedPinger((p) => !p)
    setPatientData({
      ...patientData,
      Diagnosis: finalDiagnosis,
    })
    showOnlyNoteDiagnosis()
  }

  const fetchhDiagnosisMaster = async () => {
    let formattedDataDiagnosis
    formattedDataDiagnosis = await GetDiagnosisData()
    let allDiagnosisCodes = {}
    if (formattedDataDiagnosis) {
      formattedDataDiagnosis = JSON.parse(formattedDataDiagnosis?.d)?.Data
      for (const diagnosis of formattedDataDiagnosis) {
        allDiagnosisCodes[diagnosis.Name.trim()] = diagnosis.Code
      }
    }
    setDiagnosisCodes(allDiagnosisCodes)
    setMasterDiagnosisData(formattedDataDiagnosis)
    return formattedDataDiagnosis || []
  }

  // const getPatientDiagnosis = async () => {
  //     let diagnosisData = await ModifyPatientMap('GETALL', patientID, '')

  //     let tempData = JSON.parse(diagnosisData.d)?.Data

  //     diagnosisData = tempData.filter((obj) => {
  //         if (patientID == obj.PatientID) {
  //             return obj
  //         }
  //     })

  //     let patientD = []
  //     try {
  //         patientD = diagnosisData[0]?.Diagnosis?.split(',')?.filter(item => item)
  //     } catch (e) { }
  //     // setPatientDiagnosis(patientD) patient diagnosis was setting from here we have diagnosis note wise
  //     let plans = {}
  //     let assessment = {}
  //     patientD?.forEach((item) => {
  //         ; (plans[item] = ''),
  //             (assessment[item] = {
  //                 MobilityAssessment: {},
  //                 POA: '',
  //                 MorseScore: {},
  //                 LabImaging: '',
  //                 FreeType: '',
  //                 selfCareAssessment: {},
  //             })
  //     })

  //     // noteStructureRef.current = {
  //     //   ...noteStructureRef.current,
  //     //   plans,
  //     // }

  //     // if (patientD && patientD.length > 0) {
  //     //     setPatientDiagnosis(patientD)
  //     // }

  //     let allDiagnosisName = ''
  //        const diagnosisIds = noteStructureRef.current?.metadata?.diagnosisIds
  //      let response = await GetDiagnosisData('')
  //          response = JSON.parse(response.d)?.Data
  //          const filteredNoteDiagnosis = response?.filter((item) => diagnosisIds.includes(item.id))

  //             if (filteredNoteDiagnosis?.length > 0) {

  //                 allDiagnosisName = filteredNoteDiagnosis.map((item) => item.Name).toString()
  //                 // setPatientDiagnosis(filteredNoteDiagnosis.map((item) => item.Name))
  //             } else {
  //                 // setPatientDiagnosis([])
  //             }

  //               setDiagnosisData(diagnosisData)

  //     await showOnlyNoteDiagnosis()
  // }

  const getPatientDiagnosis = async () => {
    if (!hasValidPatientContext) {
      setDiagnosisData([])
      setPatientDiagnosis([])
      return []
    }

    let diagnosisData = await ModifyPatientMap('GETALL', patientID, '')
    let tempData = JSON.parse(diagnosisData.d)?.Data || []

    diagnosisData = tempData.filter((obj) => obj.PatientID == patientID)

    let allDiagnosisName = ''
    const diagnosisIds = noteStructureRef.current?.metadata?.diagnosisIds || []

    let response = MasterDiagnosisData
    if (!Array.isArray(response) || response.length === 0) {
      const diagnosisResponse = await GetDiagnosisData('')
      response = JSON.parse(diagnosisResponse.d)?.Data || []
    }

    const filteredNoteDiagnosis = response.filter((item) => diagnosisIds.includes(item.id))

    if (filteredNoteDiagnosis.length > 0) {
      allDiagnosisName = filteredNoteDiagnosis.map((item) => item.Name).join(',')
    }

    if (diagnosisData.length > 0) {
      diagnosisData = diagnosisData.map((item) => ({
        ...item,
        Diagnosis: allDiagnosisName,
      }))
    }

    setDiagnosisData(diagnosisData)

    await showOnlyNoteDiagnosis()
    return diagnosisData
  }

  const handleTabClick = (index) => {
    // autoSaveTreatsShell()
    setActiveTab(index)
  }

  const loadImagingBundle = async () => {
    let resolvedImagingTypes = imagingTypeList

    if (!Array.isArray(resolvedImagingTypes) || resolvedImagingTypes.length === 0) {
      resolvedImagingTypes = (await ensureSectionLoaded('imaging-types', getData)) || []
    }

    return ensureSectionLoaded('patient-imaging', () => GetPatientImagings(resolvedImagingTypes.length > 0 ? resolvedImagingTypes : imagingTypeList))
  }

  const refreshImagingSection = async () => {
    delete sectionLoadStateRef.current['patient-imaging']
    return loadImagingBundle()
  }

  const loadMedicationBundle = async () => {
    let resolvedMasterMedications = masterMedications

    if (!Array.isArray(resolvedMasterMedications) || resolvedMasterMedications.length === 0) {
      resolvedMasterMedications = (await ensureSectionLoaded('master-medications', GetMasterMedications)) || []
    }

    return ensureSectionLoaded('patient-medications', () => fetchMedications(resolvedMasterMedications.length > 0 ? resolvedMasterMedications : masterMedications))
  }

  const loadFinalNoteBundle = async () => {
    await Promise.all([
      ensureSectionLoaded('history-records', getHistory),
      ensureSectionLoaded('personal-histories', getPersonalHistoryData),
      ensureSectionLoaded('patient-vitals', getPatientVitals),
      ensureSectionLoaded('patient-allergies', fetchAllergies),
      ensureSectionLoaded('patient-labs', fetchPatientLabs),
      loadMedicationBundle(),
      loadImagingBundle(),
      ensureSectionLoaded('addendum', fetchAddendumData),
    ])
  }

  const parsePatientTreatmentsResponse = (response) => {
    const parsedData = JSON.parse(response?.d)?.Data || []

    return parsedData.map((item) => ({
      ...item,
      data: item?.data ? JSON.parse(item?.data) : {},
    }))
  }

  const getCachedPatientTreatments = () => {
    return Array.isArray(patientTreatmentsRef.current) ? patientTreatmentsRef.current : []
  }

  const setPatientTreatmentsCache = (notes = []) => {
    patientTreatmentsRef.current = Array.isArray(notes) ? notes : []
    setPatientTreatments(Array.isArray(notes) ? notes : [])
    return Array.isArray(notes) ? notes : []
  }

  const fetchPatientTreatmentsList = async ({ useCache = false } = {}) => {
    if (!hasValidPatientContext) {
      return []
    }

    if (useCache) {
      const cachedNotes = getCachedPatientTreatments()
      if (cachedNotes.length > 0) {
        return cachedNotes
      }
    }

    const response = await PatientNoteDataCRUD('GET', patientID)
    return parsePatientTreatmentsResponse(response)
  }

  const getDiagnosisInformationSources = (information = {}, diagnosis = '') => {
    const normalizedDiagnosis = diagnosis?.trim()?.toLowerCase()
    const informationKey = Object.keys(information || {}).find(
      (key) => key?.trim()?.toLowerCase() === normalizedDiagnosis
    )
    const sources = informationKey ? information[informationKey] : []
    return Array.isArray(sources) ? sources : sources ? [sources] : []
  }

  const getCarryForwardDiagnosisInfo = (previousInformation = {}, diagnosis = '') => {
    const previousSources = getDiagnosisInformationSources(previousInformation, diagnosis)
    const cleanedSources = previousSources
      .map((source) => source?.trim())
      .filter(Boolean)
      .filter((source) => source !== 'Carry Forwarded from Previous Note')

    return ['Carry Forwarded from Previous Note', ...cleanedSources]
  }

  const hydrateCarryForwardInformation = (currentNoteData = {}, previousNoteData = {}) => {
    if (!currentNoteData?.isCarryForward || !previousNoteData?.information) {
      return currentNoteData
    }

    const carriedDiagnosisIds = currentNoteData?.metadata?.diagnosisIds || []
    const carriedDiagnosisNames = MasterDiagnosisData
      .filter((diagnosis) => carriedDiagnosisIds.includes(diagnosis.id))
      .map((diagnosis) => diagnosis.Name)

    if (carriedDiagnosisNames.length === 0) {
      return currentNoteData
    }

    const information = {
      ...(currentNoteData.information || {}),
    }

    carriedDiagnosisNames.forEach((diagnosis) => {
      const currentSources = getDiagnosisInformationSources(information, diagnosis)
      if (currentSources.length === 0 || currentSources.includes('Carry Forwarded from Previous Note')) {
        information[diagnosis] = getCarryForwardDiagnosisInfo(previousNoteData.information, diagnosis)
      }
    })

    return {
      ...currentNoteData,
      information,
    }
  }

  const syncLatestPatientTreatmentPointers = (notes = []) => {
    if (!Array.isArray(notes) || notes.length === 0) {
      return null
    }

    const latestNote = notes.at(-1) || null

    setEditDataId(latestNote?.id || null)
    setNoteID(notes.length)
    setDataCallType('edit')

    return {
      noteId: latestNote?.id || null,
      noteIndexID: notes.length,
    }
  }

  // get patient history
  const getHistory = async () => {
    if (!hasValidPatientContext) {
      setAllHistory([])
      return []
    }

    let allData = await ModifyPatientHistory('GET', patientID)
    let history = JSON.parse(allData?.d)
    setAllHistory(history?.Data)

    return history?.Data || []
  }

  // const addScheduleAppointmentDatatoNote = async () => {
  //   if (noteStructureRef.current?.appointmentDetails || !setDataId || !appointments || !patientID || patientTreatments.length === 0) {
  //     return
  //   }
  //   let filterPatientAppointments = appointments && appointments.length > 0 && appointments.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled'))
  //   if (filterPatientAppointments.length > 0) {
  //     const findCurrentNoteScheduleData = filterPatientAppointments.find((item) => item.data.NoteID === setDataId)
  //     if (findCurrentNoteScheduleData) {
  //       noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         appointmentDetails: findCurrentNoteScheduleData,
  //       }
  //       await saveTreatsShell(false)
  //     }
  //   }
  // }

  // useEffect(() => {
  //   addScheduleAppointmentDatatoNote()
  // }, [noteStructureRef.current?.appointmentDetails, appointments, setDataId, patientID, patientTreatments])

  const SyncAppointmentData = async (noteID) => {
    let appointmentDetails = []
    if (appointments.length === 0) {
      appointmentDetails = await getAllAppointmentsDetails('GET')
    } else {
      appointmentDetails = appointments
    }
    let filterPatient = appointmentDetails && appointmentDetails.length > 0 && appointmentDetails.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled') && !item.data.NoteID)
    let filterPatientss = appointmentDetails && appointmentDetails.length > 0 && appointmentDetails.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled'))

    try {
      if (filterPatient.length > 0) {
        if (noteID !== null && noteID !== undefined) {
          handleAddNoteId(noteID, appointmentDetails)
          // addScheduleAppointmentDatatoNote()
        }
      }
    } catch (error) {
      console.error('Error syncing appointment data:', error)
    }
  }
  // Get Patient Treatments

  const GetPatientTreatmentsNotes = async () => {
    if (!hasValidPatientContext) {
      patientTreatmentsRef.current = []
      setPatientTreatments([])
      return []
    }

    try {
      let data = await fetchPatientTreatmentsList()

      if (data) {
        console.log(data, 'data')

        // noteStructureRef.current = data[noteID]?.data
        // setSelectedRisks(data[noteID]?.data.riskFactors || {})
        noteStructureRef.current = hydrateCarryForwardInformation(data[noteID]?.data, data[noteID - 1]?.data)

        if (data?.length === 0) {
          let provideInformation = String(patientData?.Diagnosis || '')
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean)

          let information = provideInformation.reduce((acc, item) => {
            acc[item] = ['Patient Added']
            return acc
          }, {})
          let assessment = {}

          patientDiagnosis.forEach((item) => {
            assessment[item] = {
              MobilityAssessment: {},
              POA: '',
              MorseScore: {},
              LabImaging: '',
              FreeType: '',
              selfCareAssessment: {},
            }
          })

          noteStructureRef.current = {
            ...noteStructureRef.current,
            information,
            assessment,
          }
          SyncAppointmentData(data[noteID]?.id)
        } else {
          SyncAppointmentData(data[noteID]?.id)
          if (data[noteID]?.data.orderFlag === false || noteID === 0 || data[noteID]?.status === 'Submitted' || (data[noteID]?.flag == 'true' && data[noteID]?.status == 'Draft') || data[noteID]?.status === 'Signed') {
            setShowOrderPopUp(false)
          }

          try {
            let filterPatient = appointments && appointments.length > 0 && appointments.filter((item) => item?.current?.Patient?.value === patientID && item?.data?.Status === 'Finish')
            let lastAppointmentDate = filterPatient?.[filterPatient.length - 1]?.data?.CreatedDate || null
            if (lastAppointmentDate) {
              const datePart = lastAppointmentDate.split('T')[0]
              const usFormattedDate = new Date(datePart).toLocaleDateString('en-US')
              setAppointmentData(usFormattedDate)
            } else {
              setAppointmentData(filterPatient?.[0]?.data?.StartTime || '')
            }
          } catch (error) {
            console.error('Error processing appointment data:', error)
            setAppointmentData(null)
          }
          // if (filterPatient.length > 0) {
          //   handleAddNoteId(data[noteID].id || null)
          // }

          if (!data[noteID]?.data.information) {
            noteStructureRef.current = {
              ...noteStructureRef.current,
              information: data[0]?.data.information || {},
            }
          }
          if (data[noteID]?.data.riskFactors) {
            setSelectedRisks(data[noteID]?.data.riskFactors || {})
          }

          // let assessment = {}

          // patientDiagnosis.forEach((item) => {
          //   assessment[item] = {
          //     MobilityAssessment: {},
          //     POA: "",
          //     MorseScore: {},
          //     LabImaging: "",
          //     FreeType: "",
          //   }
          // })
          // noteStructureRef.current = {
          //   ...noteStructureRef.current,
          //   assessment: assessment
          // }
        }

        return setPatientTreatmentsCache(data)
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
    }
    return []
  }
  // noteStructureRef.current = {
  //     ...noteStructureRef.current,
  // }
  // patient imaging =================================================================>>>>
  const [imagingTypeList, setImagingTypeList] = useState([])
  const [imagingList, setImagingList] = useState([])

  const getData = async () => {
    try {
      const data = await ImagingInformation('GET_ALL')
      if (data) {
        const formattedData = JSON.parse(data.d)?.Data
        const allFormattedData = formattedData
          .filter((item) => item.Keywords !== '')
          .map((item) => {
            return {
              ...item,
              Keywords: JSON.parse(JSON.parse(item.Keywords)),
            }
          })
        setImagingTypeList(allFormattedData)
        return allFormattedData
      }
    } catch (error) {
      console.error('Error fetching imaging data', error)
    }
    return []
  }

  const extractUniqueKeywords = (keywordsArray) => {
    // const allKeywords = keywordsArray.flatMap((item) => item.keyword.split(',')).map((keyword) => keyword.trim())
    const allKeywords = Array.isArray(keywordsArray) ? keywordsArray.flatMap((item) => (typeof item?.keyword === 'string' ? item.keyword.split(',').map((k) => k.trim()) : [])) : []

    const uniqueKeywords = Array.from(new Set(allKeywords))

    return uniqueKeywords
  }

  // get master medications
  const GetMasterMedications = async () => {
    try {
      let allMedicines = await MedicineCRUD('GET')
      let formattedData = JSON.parse(allMedicines.d)?.Data
      if (formattedData) {
        formattedData = formattedData.map((item) => {
          let itemData = JSON.parse(item.Data)
          return {
            ...item,
            Data: {
              ...itemData,
              diagnoses: itemData.diagnoses.split(',').map((diagnosis) => diagnosis.trim()),
            },
          }
        })
        setMasterMedications(formattedData)
        return formattedData
      }
    } catch (error) {
      console.error('Error fetching master medications:', error)
    }
    return []
  }

  // get patient imaging
  const GetPatientImagings = async (imagingTypes = imagingTypeList) => {
    if (!hasValidPatientContext) {
      setImagingList([])
      return []
    }

    try {
      let formattedData = await PatientImagingsCRUD('GET', patientID.toString())
      if (formattedData) {
        formattedData = JSON.parse(formattedData.d)
        formattedData = formattedData.Data.map((item) => {
          const parsedData = JSON.parse(item.data)
          const matchingType =
            parsedData &&
            imagingTypes.find((type) => {
              return type.Name.toString() === parsedData.name.toString()
            })
          return {
            ...item,
            data: {
              ...parsedData,
              keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
            },
          }
        })
        // formattedData.sort((a, b) => Number(a?.data?.priority || 0) - Number(b?.data?.priority || 0))
        // formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))
        formattedData.sort((a, b) => {
          const priorityA = Number(a?.data?.priority || 0)
          const priorityB = Number(b?.data?.priority || 0)

          if (priorityA !== priorityB) {
            return priorityA - priorityB // sortt by priority
          }

          const dateA = new Date(a?.date).getTime()
          const dateB = new Date(b?.date).getTime()

          return dateB - dateA // soort by date descending
        })

        setImagingList(formattedData)
        return formattedData
      }
    } catch (error) {
      console.error('Error fetching patient imaging data', error)
    }
    return []
  }

  // useEffect(() => {
  //   setIsPatientPageLoading(true)
  //   try {
  //     const fetchData = async () => {
  //       await getData();
  //       await GetMasterMedications()
  //       await getHistory()
  //       await GetPatientImagings();
  //       await getPatientVitals()
  //       await fetchMedications()
  //       await fetchPatientLabs()
  //       await fetchAllergies()
  //       await fetchhDiagnosisMaster()
  //       await fetchOrders()
  //       await GetPatientTreatmentsNotes()
  //     };
  //     fetchData();
  //   } catch (error) {
  //     console.log(error)
  //   }
  //   finally{
  //     setIsPatientPageLoading(false)
  //   }
  // }, [patientID, reRender]);

  useEffect(() => {
    if (!hasValidPatientContext) {
      return
    }

    const preservedGlobalSections = {
      'diagnosis-master': sectionLoadStateRef.current['diagnosis-master'],
      'master-medications': sectionLoadStateRef.current['master-medications'],
      'imaging-types': sectionLoadStateRef.current['imaging-types'],
    }

    sectionLoadStateRef.current = preservedGlobalSections
    patientTreatmentsRef.current = []
    setPatientTreatments([])
    setAllHistory([])
    setAllergiesList([])
    setAllLabs([])
    setPatientOrders([])
    setMedicationList([])
    setVitalsList([])
    setImagingList([])
    setAddendum([])
    setPastOrders([])
    setShowOrderPopUpYN(false)
    setHistories({
      pmhx: [],
      pshx: [],
      fh: [],
      sh: [],
    })
  }, [patientID])

  useEffect(() => {
    if (!hasValidPatientContext) {
      return
    }

    const loadBasePageData = async () => {
      setIsPatientPageLoading(true)
      try {
        await Promise.all([ensureSectionLoaded('appointments', getAppointmentData), ensureSectionLoaded('diagnosis-master', fetchhDiagnosisMaster)])
      } catch (error) {
        console.error('Error fetching patient base data:', error)
      } finally {
        setIsPatientPageLoading(false)
      }
    }

    loadBasePageData()
  }, [patientID])

  useEffect(() => {
    if (!hasValidNoteContext) {
      return
    }

    const loadCurrentNoteData = async () => {
      setIsPatientPageLoading(true)
      try {
        await Promise.all([ensureSectionLoaded('diagnosis-master', fetchhDiagnosisMaster), GetPatientTreatmentsNotes()])
        await getPatientDiagnosis()
        ensureSectionLoaded('past-orders', fetchPastOrders).catch((error) => {
          console.error('Error preloading past orders:', error)
        })
      } catch (error) {
        console.error('Error fetching patient note data:', error)
      } finally {
        setIsPatientPageLoading(false)
      }
    }

    loadCurrentNoteData()
  }, [patientID, noteID, reRender])
  // patient imaging =================================================================>>>>

  // all master imaging gets

  // all master imaging gets

  // patient vitals ============

  const getPatientVitals = async () => {
    if (!hasValidPatientContext) {
      setVitalsList([])
      return []
    }

    let allVital = { PatientID: patientID }
    allVital = [allVital]
    let allData
    allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))
    allData = JSON.parse(allData.d) || {}
    setVitalsList(allData?.Data)
    return allData?.Data || []
  }
  // patient vitals ============

  // patient labs ============

  // scroll
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const fetchPatientLabs = async () => {
    try {
      let formattedData
      formattedData = await PatientLabsCRUD('GET', patientID.toString())
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      formattedData.sort((a, b) => b.id - a.id)
      setAllLabs(formattedData)
      return formattedData
    } catch (error) {
      console.log(error)
    }
  }
  // patient labs ============

  //  <<<<<========= patient medications =================================================================>>>>>
  const fetchMedications = async (masterMedicationSource = masterMedications) => {
    if (!hasValidPatientContext) {
      setMedicationList([])
      return []
    }

    let formattedData
    formattedData = await PatientMedications('GET', patientID.toString())
    formattedData = JSON.parse(formattedData.d)
    formattedData = formattedData?.Data
    // if (formattedData) {
    //     formattedData = formattedData.map((item) => {
    //         return {
    //             ...item,
    //             data: JSON.parse(item.data),
    //         }
    //     })
    // }
    formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))
    const masterMedsNames = (masterMedicationSource || []).map((med) => med.Data?.name?.toLowerCase())

    if (formattedData) {
      formattedData = formattedData.map((item) => {
        const medicationAllData = JSON.parse(item?.data)
        const updatedData = Array.isArray(JSON.parse(item?.data))
          ? medicationAllData.map((med) => ({
            ...med,
            inMaster: masterMedsNames.includes(med?.name?.toLowerCase()),
          }))
          : []
        updatedData.sort((a, b) => (a.inMaster === b.inMaster ? 0 : a.inMaster ? -1 : 1))

        return {
          ...item,
          data: updatedData,
        }
      })
    }

    setMedicationList(formattedData)
    return formattedData
  }
  //  <<<<<========= patient medications =================================================================>>>>>

  // patient allergies
  const fetchAllergies = async () => {
    if (!hasValidPatientContext) {
      setAllergiesList([])
      return []
    }

    try {
      let formattedData
      formattedData = await GetPatientAllergiesCRUD('GET', patientID)
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      setAllergiesList(formattedData)
      return formattedData
    } catch (error) { }
    return []
  }
  // patient allergies

  // patient orders

  const fetchOrders = async () => {
    if (!hasValidPatientContext) {
      setPatientOrders([])
      return []
    }

    try {
      let formattedData
      formattedData = await PatientOrdersCRUD('GET', patientID)
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData.map((item, idx) => {
          return {
            ...item,
            medication: item.medication == '' ? [] : JSON.parse(item.medication),
            imaging: item.imaging.length > 0 ? JSON.parse(item?.imaging) : {},
            medication: item.medication ? JSON.parse(item.medication) : {},
            labs: item.labs.length > 0 ? JSON.parse(item?.labs) : {},
          }
        })
      }
      setPatientOrders(formattedData)
      return formattedData
    } catch (error) {
      console.log(error)
    }
    return []
  }

  // patient orders

  useEffect(() => {
    if (!hasValidPatientContext) {
      return
    }

    if (!hasRenderedDiagnosisRefreshRef.current) {
      hasRenderedDiagnosisRefreshRef.current = true
      return
    }

    const refreshDiagnosisData = async () => {
      setLoading(true)
      try {
        await getPatientDiagnosis()
      } finally {
        setLoading(false)
      }
    }

    refreshDiagnosisData()
  }, [diagnosisAddedPinger, patientID])

  // Define an array of nav links
  const navLinks = [
    // { title: 'FaceSheet', tab: 1 },
    { title: 'Demographics', tab: 0 },
    { title: 'Hospital Records', tab: 2 },
    { title: 'History', tab: 3 },
    { title: 'Internal Notes', tab: 4 },
    { title: 'Vitals', tab: 5 },
    { title: 'Allergies', tab: 13 },
    { title: 'Imaging', tab: 6 },
    { title: 'Labs', tab: 7 },
    { title: 'Medication', tab: 8 },
    { title: 'Reports', tab: 16 },
    { title: 'Psychiatry Note', tab: 17 },
    { title: 'Final Note', tab: 10 },
    { title: 'Past Order', tab: 9 },

    // { title: 'HPI Questions', tab: 17 },
    { title: 'Addendum', tab: 18 },
    { title: 'Past Notes', tab: 20 },

    // { title: 'Treatment Plan', tab: 10 },
    // { title: 'Assessment', tab: 11 },
    // { title: 'Final Note', tab: 12 },
    // Add more nav links here
  ]

  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  useEffect(() => {
    dispatch({ type: 'set', sidebarShow: false })
    getFacilities()
  }, [])

  useEffect(() => {
    delete sectionLoadStateRef.current.addendum
    delete sectionLoadStateRef.current['past-orders']
    setAddendum([])
    setPastOrders([])
    setShowOrderPopUpYN(false)
  }, [patientID, noteID])

  useEffect(() => {
    if (!hasValidPatientContext) {
      return
    }

    const tabLoaders = {
      2: () => ensureSectionLoaded('history-records', getHistory),
      3: () => ensureSectionLoaded('personal-histories', getPersonalHistoryData),
      5: () => ensureSectionLoaded('patient-vitals', getPatientVitals),
      6: loadImagingBundle,
      7: () => ensureSectionLoaded('patient-labs', fetchPatientLabs),
      8: loadMedicationBundle,
      9: () => ensureSectionLoaded('past-orders', fetchPastOrders),
      10: loadFinalNoteBundle,
      13: () => ensureSectionLoaded('patient-allergies', fetchAllergies),
      18: () => ensureSectionLoaded('addendum', fetchAddendumData),
    }

    const loader = tabLoaders[activeTab]

    if (loader) {
      loader().catch((error) => {
        console.error(`Error loading deferred data for tab ${activeTab}:`, error)
      })
    }
  }, [activeTab, patientID, noteID])

  useEffect(() => {
    if (!hasValidPatientContext || (!modalVisible && !noteView && !showNoteView)) {
      return
    }

    loadFinalNoteBundle().catch((error) => {
      console.error('Error loading note detail data:', error)
    })
  }, [modalVisible, noteView, showNoteView, patientID, noteID])

  const handleInsertData = async (prefetchedNotes = null) => {
    try {
      const data = Array.isArray(prefetchedNotes) && prefetchedNotes.length > 0 ? prefetchedNotes : await fetchPatientTreatmentsList({ useCache: true })

      if (Array.isArray(data) && data.length > 0) {
        setPatientTreatmentsCache(data)
        syncLatestPatientTreatmentPointers(data)
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
    }
  }

  const handleSaveModule = () => {
    if (patientTreatments && patientTreatments.length > 0) {
      let setUpID = patientTreatments[noteID]

      if (setUpID?.status === 'Submitted') {
        setShowSaveModel(true)
      } else if (setUpID?.status === 'Signed') {
        setSignModel(true)
      } else {
        saveTreatsShell()
      }
    } else {
      saveTreatsShell()
    }
  }

  const checkInternet = async () => {
    try {
      await fetch('https://www.google.com/favicon.ico', {
        mode: 'no-cors',
        cache: 'no-store',
      })
      return true
    } catch {
      return false
    }
  }


  const handleSubmitModule = async () => {
    if (!(await checkInternet())) {
      toast.error('No internet connection. Please check your network.', toastConfig)
      return
    }
    if (patientTreatments && patientTreatments.length > 0) {
      let setUpID = patientTreatments[noteID]
      if (setUpID?.status === 'Signed') {
        setSignModel(true)
      } else {
        submitNotes()
      }
    } else {
      submitNotes()
    }
  }

  useEffect(() => {
    const settingNoteIdFunc = async () => {
      // Only aded noteID if the key does not exist in the object
      if (noteStructureRef && noteStructureRef.current) {
        if (!Object.prototype.hasOwnProperty.call(noteStructureRef.current, 'noteID')) {
          noteStructureRef.current = {
            ...noteStructureRef.current,
            noteID: Number(noteID),
          }
        }
        await PatientNoteDataCRUD('UPDATE', patientID.toString(), setDataId, JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
      }
      if (noteStructureRef.current) {
        settingNoteIdFunc()
      }
    }
  }, [noteStructureRef.current])

  const saveTreatsShell = async (showAlert = true) => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      // DifferentialDiagnosis: null,
      noteID: Number(noteID),
    }
    if (patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit') {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      let setUpID = patientTreatments[noteID] && patientTreatments[noteID]?.id
      let statuToCurrentNoteSave = (patientTreatments[noteID] && patientTreatments[noteID]?.status) || 'Draft'
      let flag = (patientTreatments[noteID] && patientTreatments[noteID]?.flag) || 'false'
      await SyncAppointmentData(setUpID)
      await PatientDataCRUD('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), statuToCurrentNoteSave?.toString(), flag?.toString())
      await GetPatientTreatmentsNotes()
      if (showAlert) {
        toast.success('Successfully Saved', toastConfig)
      }
    } else {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Draft', 'false')
      if (showAlert) {
        toast.success('Successfully Note Created', toastConfig)
      }

      const refreshedNotes = await GetPatientTreatmentsNotes()
      await handleInsertData(refreshedNotes)
    }
  }

  const saveTreatsShellForHospitalRecord = async (showAlert = true, updateNoteStructure) => {
    // build snapshot safely
    const noteSnapshot = {
      ...(updateNoteStructure || {}),
      noteID: Number(noteID),
    }

    const formattedJson = JSON.stringify(noteSnapshot)

    if (patientTreatments?.length > 0 && dataCallType === 'edit') {
      const setUpID = patientTreatments?.[noteID]?.id

      const statuToCurrentNoteSave = patientTreatments?.[noteID]?.status || 'Draft'

      const flag = patientTreatments?.[noteID]?.flag || 'false'

      await PatientDataCRUD('UPDATE', patientID.toString(), setUpID?.toString(), formattedJson, getFormattedDate().toString(), statuToCurrentNoteSave.toString(), flag.toString())

      await GetPatientTreatmentsNotes()

      if (showAlert) {
        toast.success('Successfully Saved', toastConfig)
      }
    } else {
      await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Draft', 'false')

      if (showAlert) {
        toast.success('Successfully Note Created', toastConfig)
      }

      const refreshedNotes = await GetPatientTreatmentsNotes()
      await handleInsertData(refreshedNotes)
    }
  }

  // const addPersonalHistoriesInitially = async () => {
  //   const personalHistoryIDs = {};
  //   const surgical = await getPatientPersonalHistory('INSERT', patientID, 'SurgicalHistory', '', "No surgical hx found.");
  //   const family = await getPatientPersonalHistory('INSERT', patientID, 'FamilyHistory', '', "Noncontributory.");
  //   const social = await getPatientPersonalHistory('INSERT', patientID, 'SocialHistory', '', "Pt denies any hx of tobacco, alcohol or any illict drug use.");

  //   personalHistoryIDs.SurgicalHistory = JSON.parse(surgical.d).Data[0].Id;
  //   personalHistoryIDs.FamilyHistory = JSON.parse(family.d).Data[0].Id;
  //   personalHistoryIDs.SocialHistory = JSON.parse(social.d).Data[0].Id;

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     isInitialHistoriesAdded: true,
  //     metadata: {
  //       ...noteStructureRef.current.metadata,
  //       ...personalHistoryIDs
  //     },
  //   }

  //   await saveTreatsShell(false)
  // };

  // useEffect(() => {
  //   if (creatingNewNote && patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit' && !noteStructureRef.current.isInitialHistoriesAdded) {
  //     addPersonalHistoriesInitially();
  //   }
  // }, [patientTreatments])

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const handleAddMedicationData = async () => {
    if (patientID == null || noteID == null || patientID === -1 || noteID === -1) {
      return
    }
    let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
    let allData = JSON.parse(data?.d)

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
    if (!result) {
      // if (patientData?.Status === 'Follow Up' && noteID === 0) {
      if (true) {
        const finalHpiStructure = {
          [patientID]: {
            [noteID]: {
              HPI: {},
              medicationRemarksForSubjective: '',
              data: 'Greater than 50% of the total time was spent on coordinating care, reviewing labs, imaging, and speaking with nursing and ancillary staff.',
            },
          },
        }
        let data = await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
      }
    } else {
      console.log('insert the data here already')
    }
  }

  const [physicalExaminationData, setPhysicalExaminationData] = useState([])
  const [isPageLoadingParent, setIsPageLoadingParent] = useState(false)
  const [globalRemarkTextToShow, setGlobalRemarkTextToShow] = useState('')
  const [globalRemarkText, setGlobalRemarkText] = useState('')
  const [updatePE, setUpdatePE] = useState(false)
  const handleAddPE = async () => {
    try {
      if (noteID === undefined || noteID === null || Number(noteID) <= 0) {
        console.warn('Invalid noteID, skipping Physical Examination copy')
        return
      }
      let previewsNoteID = noteID > 0 ? noteID - 1 : 0

      const isPEExit = await PatientPhysicalExaminationData('Get_By_Patient', patientID, noteID)
      const parsedCurrentData = JSON.parse(isPEExit?.d).Data || []

      let isExit = await parsedCurrentData?.some((item) => item?.NoteID == noteID)

      if (isExit) {
        return
      } else {
        let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID, previewsNoteID)

        const parsedData = JSON.parse(response.d).Data || []
        const findLastDiagnosisExaminationData = parsedData.filter((item) => item.Type === 'DiagnosisExaminationData' && item.NoteID == previewsNoteID) || []
        const findLastGeneralDiagnosisExamination = parsedData.filter((item) => item.Type === 'GeneralExaminationData' && item.NoteID == previewsNoteID) || []

        const globalRemarks = parsedData.filter((item) => item.Type === 'PhysicalExaminationGlobalRemark' && item?.NoteID === previewsNoteID?.toString())

        const lastGlobalRemark = globalRemarks[globalRemarks.length - 1] || null

        const jsonRemarkGlobalRemark = lastGlobalRemark ? JSON.parse(lastGlobalRemark.JsonData) : null

        //   setGlobalRemarkTextToShow(jsonRemarkGlobalRemark?.globalRemarkText || "")
        //   setGlobalRemarkText(jsonRemarkGlobalRemark?.globalRemarkText || '')

        const GEData = (() => {
          try {
            return JSON.parse(findLastGeneralDiagnosisExamination?.[findLastGeneralDiagnosisExamination.length - 1]?.JsonData || '[]')
          } catch (e) {
            console.error('Invalid GEData JSON:', e)
            return []
          }
        })()

        const PEDiagnosisData = (() => {
          try {
            return JSON.parse(findLastDiagnosisExaminationData?.[findLastDiagnosisExaminationData.length - 1]?.JsonData || '[]')
          } catch (e) {
            console.error('Invalid PEDiagnosisData JSON:', e)
            return []
          }
        })()

        const addPE = async (type, data) => {
          try {
            let response = await PatientPhysicalExaminationData('Insert', patientID, noteID, type, JSON.stringify(data))
          } catch (error) {
            toast.error('Failed to save General Examination Data', toastConfig)
            console.error('Error saving General Examination Data:', error)
          } finally {
            setIsPageLoading(false)
          }
        }

        await addPE('GeneralExaminationData', GEData)
        await addPE('DiagnosisExaminationData', PEDiagnosisData)
        await addPE('PhysicalExaminationGlobalRemark', jsonRemarkGlobalRemark?.globalRemarkText ? jsonRemarkGlobalRemark : { globalRemarkText: '' })
        // setPhysicalExaminationData([...GEData , ...PEDiagnosisData])
      }
    } catch (error) {
      console.log('physical examination erro', error)
    } finally {
      setUpdatePE(true)
    }

    //   if (isPEExit.length > 0) {
    //      const parsedData = JSON.parse(isPEExit.d).Data || []

    //      const findLastDiagnosisExaminationData = parsedData.filter((item) => item.Type === 'DiagnosisExaminationData' && item.NoteID == noteID) || []
    //      const findLastGeneralDiagnosisExamination = parsedData.filter((item) => item.Type === 'GeneralExaminationData' && item.NoteID == noteID) || []

    //     if(findLastDiagnosisExaminationData.length > 0 || findLastGeneralDiagnosisExamination.length > 0){
    //       return
    //     }
    //   }
  }

  useEffect(() => {
    handleAddMedicationData()
    // if (noteID !== null || noteID !== undefined){
    //      handleAddPE()
    //    }
    handleAddPE()
  }, [patientID, noteID])

  const autoSaveTreatsShell = async () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      // DifferentialDiagnosis: null,
      noteID,
    }

    if (patientTreatments && patientTreatments.length > 0 && dataCallType === 'edit') {
      const formattedJson = JSON.stringify(noteStructureRef.current)
      let setUpID = patientTreatments[noteID] && patientTreatments[noteID]?.id
      let status = patientTreatments[noteID] && patientTreatments[noteID]?.status
      let flag = patientTreatments[noteID] && patientTreatments[noteID]?.flag

      await PatientDataCRUD('UPDATE', patientID.toString(), setUpID.toString(), formattedJson, getFormattedDate().toString(), status, flag)
      await GetPatientTreatmentsNotes()
    } else {
      const formattedJson = JSON.stringify(noteStructureRef.current)

      await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString())
      const refreshedNotes = await GetPatientTreatmentsNotes()
      await handleInsertData(refreshedNotes)
    }
  }

  const isNoteIdLink = async () => {
    let appointmentDetails = []

    if (appointments.length === 0) {
      appointmentDetails = await getAllAppointmentsDetails('GET')
    } else {
      appointmentDetails = appointments
    }

    let filterPatient = appointmentDetails && appointmentDetails.length > 0 && appointmentDetails.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled') && !item.data.NoteID)

    try {
      if (filterPatient.length > 0) {
        if (noteID !== null && noteID !== undefined) {
          handleAddNoteId(noteID, appointmentDetails)
          // addScheduleAppointmentDatatoNote()
        }
      }
    } catch (error) {
      console.error('Error syncing appointment data:', error)
    }
  }

  const handleIdsData = async () => {
    try {
      let data = getCachedPatientTreatments()

      if (data.length === 0) {
        data = await fetchPatientTreatmentsList()
        setPatientTreatmentsCache(data)
      }

      if (Array.isArray(data) && data.length > 0) {
        return syncLatestPatientTreatmentPointers(data)
      }
    } catch (error) {
      // toast.error('error in patient treatment', toastConfig)
      console.error('Error fetching patient orders', error)
    }
  }
  // const submitNotes = async () => {
  //   setSubmitLoader(true)


  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     // DifferentialDiagnosis: null,
  //     noteID,
  //   }

  //   const formattedJson = JSON.stringify(noteStructureRef.current)

  //   if (!setDataId) {
  //     const dataReturn = await handleIdsData()
  //     await SyncAppointmentData(dataReturn?.noteId)
  //     await PatientDataCRUD('UPDATE', patientID.toString(), dataReturn?.noteId?.toString(), formattedJson, getFormattedDate().toString(), 'Submitted', 'true')
  //     setModalVisible(false)
  //     await UpdateCheckForStatusData({ NoteStatus: "Submitted" })
  //     toast.success('Successfully Submitted', toastConfig)
  //   } else if (setDataId) {
  //     await SyncAppointmentData(setDataId)
  //     let setUpID = setDataId ? setDataId.toString() : patientTreatments[noteID] && patientTreatments[noteID]?.id
  //     await PatientDataCRUD('UPDATE', patientID.toString(), setDataId ? setDataId.toString() : setUpID.toString(), formattedJson, getFormattedDate().toString(), 'Submitted', 'true')
  //     await UpdateCheckForStatusData({ NoteStatus: "Submitted" })
  //     setModalVisible(false)
  //     toast.success('Successfully Submitted', toastConfig)
  //   } else {
  //     await PatientDataCRUD('INSERT', patientID.toString(), '', formattedJson, getFormattedDate().toString(), 'Submitted', 'true')
  //     handleInsertData()
  //     setModalVisible(false)
  //     await UpdateCheckForStatusData({ NoteStatus: "Submitted" })
  //     toast.success('Successfully Created and submitted', toastConfig)
  //   }

  //   await GetPatientTreatmentsNotes()

  //   setSubmitLoader(false)
  //   setModalVisible(false)
  // }




  const isPatientExists = async () => {
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      patientData = JSON.parse(patientData.d).Data

      const exists = patientData.some(
        (item) => item.PatientID === patientID
      )

      return exists
    } catch (error) {
      console.error("Error checking patient:", error)
      return false
    }
  }
  const submitNotes = async () => {
    setSubmitLoader(true)
    const exists = await isPatientExists()

    if (!exists) {
      toast.error('Patient is deleted', toastConfig)
      setSubmitLoader(false)
      window.location.replace(baseRoute === 'home/provider/completed-appointment'
        ? '/home/provider/completed-appointment'
        : baseRoute === 'home/provider/appointment'
          ? '/home/provider/appointment'
          : baseRoute === 'home/provider/all-patients'
            ? '/home/provider/all-patients'
            : baseRoute === 'home/all-appointment'
              ? '/home/all-appointment'
              : '/home/appointment')

      return
    }


    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Timeout")), 60000)
    )

    const mainTask = async () => {
      noteStructureRef.current = {
        ...noteStructureRef.current,
        noteID,
      }

      const formattedJson = JSON.stringify(noteStructureRef.current)

      if (!setDataId) {
        const dataReturn = await handleIdsData()
        await SyncAppointmentData(dataReturn?.noteId)
        await PatientDataCRUD(
          'UPDATE',
          patientID.toString(),
          dataReturn?.noteId?.toString(),
          formattedJson,
          getFormattedDate().toString(),
          'Submitted',
          'true'
        )
        await UpdateCheckForStatusData({ NoteStatus: "Submitted" })
        toast.success('Successfully Submitted', toastConfig)
      } else if (setDataId) {
        await SyncAppointmentData(setDataId)
        let setUpID = setDataId
          ? setDataId.toString()
          : patientTreatments[noteID]?.id

        await PatientDataCRUD(
          'UPDATE',
          patientID.toString(),
          setDataId ? setDataId.toString() : setUpID.toString(),
          formattedJson,
          getFormattedDate().toString(),
          'Submitted',
          'true'
        )
        await UpdateCheckForStatusData({ NoteStatus: "Submitted" })
        toast.success('Successfully Submitted', toastConfig)
      } else {
        await PatientDataCRUD(
          'INSERT',
          patientID.toString(),
          '',
          formattedJson,
          getFormattedDate().toString(),
          'Submitted',
          'true'
        )
        await UpdateCheckForStatusData({ NoteStatus: "Submitted" })
        toast.success('Successfully Created and submitted', toastConfig)
      }

      const refreshedNotes = await GetPatientTreatmentsNotes()
      if (!setDataId) {
        await handleInsertData(refreshedNotes)
      }
    }

    try {
      await Promise.race([mainTask(), timeoutPromise])
      setModalVisible(false)
      setSubmitLoader(false)
    } catch (err) {
      if (err.message === "Timeout") {
        toast.error("Something Went Wrong, Please try again after sometime", toastConfig)
      } else {
        console.error(err)
        toast.error("Something went wrong", toastConfig)
      }
    } finally {
      setSubmitLoader(false)
      setModalVisible(false)
    }
  }


  const updateNoteStructure = (updatedScore, updatedDate, diagnosisName, scoreType) => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      [scoreType]: {
        ...(noteStructureRef.current?.[scoreType] || {}), // ensure object
        [diagnosisName]: {
          date: updatedDate,
          score: updatedScore,
        },
      },
      assessment: {
        ...(noteStructureRef.current?.assessment || {}), // ensure object
        [diagnosisName]: {
          ...(noteStructureRef.current?.assessment?.[diagnosisName] || {}), // ensure object
          ['MorseScore']: {
            date: updatedDate,
            score: updatedScore,
          },
        },
      },
    }
  }

  const submitTreatsShell = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
    }

    setModalVisible(true)
  }

  const showOnlyNoteDiagnosis = async () => {
    const diagnosisIds = noteStructureRef.current?.metadata?.diagnosisIds
    if (Array.isArray(diagnosisIds) && diagnosisIds.length > 0) {
      try {
        let response = await GetDiagnosisData('')
        response = JSON.parse(response.d)?.Data

        const filteredNoteDiagnosis = response?.filter((item) => diagnosisIds.includes(item.id))

        if (filteredNoteDiagnosis?.length > 0) {
          setPatientDiagnosis(filteredNoteDiagnosis.map((item) => item.Name))
        } else {
          setPatientDiagnosis([])
        }
      } catch (error) {
        setPatientDiagnosis([])
        console.error('Error fetching or filtering diagnosis data:', error)
      }
    } else {
      setPatientDiagnosis([])
    }
  }

  //
  const carryForwardData = async () => {
    if (!creatingNewNote) return

    const allNotes = await fetchPatientTreatmentsList({ useCache: true })
    if (allNotes.length <= 1) return
    const lastNoteIndex = allNotes.length - 2 // get your prev data of added
    const newNoteIndex = allNotes.length - 1 // get your this note data of added
    const lastAddedNote = allNotes[lastNoteIndex]
    const newlyAddedNote = allNotes[newNoteIndex]
    const dataLastNote = lastAddedNote?.data
    let patientDiagnosisInLastNote
    const diagnosisIds = dataLastNote?.metadata?.diagnosisIds
    if (Array.isArray(diagnosisIds) && diagnosisIds.length > 0) {
      let response = await GetDiagnosisData('')
      response = JSON.parse(response.d)?.Data
      const filteredNoteDiagnosis = response?.filter((item) => diagnosisIds.includes(item.id))
      if (filteredNoteDiagnosis?.length > 0) {
        patientDiagnosisInLastNote = filteredNoteDiagnosis.map((item) => item.Name)
      }
    }
    const previousRiskFactors = dataLastNote?.riskFactors || {}
    const previousDDX = dataLastNote?.patientDifferentialDiagnosis || {}
    const previousAlert = dataLastNote?.alertData || {}
    const previousHistoryOfDiagnosis = dataLastNote?.historyOfDiagnosis || {}
    const previousFreeType = dataLastNote?.freeTypesEverything || {}
    const previousInformation = dataLastNote?.information || {}

    // const updatedInformation = Object.fromEntries(
    //     Object.keys(previousInformation).map((diagnosis) => [
    //         diagnosis,
    //         ['Carry Forwarded from Previous Note']
    //     ])
    // )

    const updatedInformation = patientDiagnosisInLastNote?.reduce((acc, diagnosis) => {
      acc[diagnosis] = getCarryForwardDiagnosisInfo(previousInformation, diagnosis)
      return acc
    }, {})

    // Temporary object to hold only the relevant data
    const carryForwardObject = {
      historyOfDiagnosis: {},
      riskFactors: {},
      metadata: {
        diagnosisIds: dataLastNote?.metadata?.diagnosisIds || [],
        allergiesIds: dataLastNote?.metadata?.allergiesIds || [],
      },
      patientDifferentialDiagnosis: {},
      alertData: {},
      assessment: {},
      plans: {},
      freeTypesEverything: previousFreeType,
      information: updatedInformation || {},
    }
    patientDiagnosisInLastNote?.filter(Boolean)?.forEach((diagnosis) => {
      const cleanedDiagnosis = diagnosis
      if (previousRiskFactors[cleanedDiagnosis]) {
        carryForwardObject.riskFactors[cleanedDiagnosis] = previousRiskFactors[cleanedDiagnosis]
        setSelectedRisks((prev) => ({
          ...prev,
          [cleanedDiagnosis]: previousRiskFactors[cleanedDiagnosis],
        }))
      }
      if (previousDDX[cleanedDiagnosis]) {
        carryForwardObject.patientDifferentialDiagnosis[cleanedDiagnosis] = previousDDX[cleanedDiagnosis]
      }
      if (previousAlert[cleanedDiagnosis]) {
        carryForwardObject.alertData[cleanedDiagnosis] = previousAlert[cleanedDiagnosis]
      }
      if (previousHistoryOfDiagnosis[cleanedDiagnosis]) {
        carryForwardObject.historyOfDiagnosis[cleanedDiagnosis] = previousHistoryOfDiagnosis[cleanedDiagnosis]
      }
      if (dataLastNote?.assessment?.[cleanedDiagnosis]?.FreeType) {
        carryForwardObject.assessment[cleanedDiagnosis] = {
          FreeType: dataLastNote.assessment[cleanedDiagnosis].FreeType,
        }
      }
      if (dataLastNote?.plans?.[cleanedDiagnosis]?.freeType) {
        carryForwardObject.plans[cleanedDiagnosis] = {
          freeType: dataLastNote.plans[cleanedDiagnosis].freeType,
        }
      }
    })
    noteStructureRef.current = {
      ...noteStructureRef.current,
      historyOfDiagnosis: carryForwardObject.historyOfDiagnosis,
      isCarryForward: true,
      riskFactors: carryForwardObject.riskFactors,
      patientDifferentialDiagnosis: carryForwardObject.patientDifferentialDiagnosis,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: carryForwardObject.metadata.diagnosisIds,
        allergiesIds: dataLastNote?.metadata?.allergiesIds || [],
      },
      freeTypesEverything: carryForwardObject.freeTypesEverything,
      assessment: carryForwardObject.assessment,
      alertData: carryForwardObject.alertData,
      plans: carryForwardObject.plans,
      information: carryForwardObject?.information || {},
    }
    await PatientNoteDataCRUD('UPDATE', patientID.toString(), newlyAddedNote?.id.toString(), JSON.stringify(noteStructureRef.current), getFormattedDate().toString(), 'Draft', false)
    await showOnlyNoteDiagnosis()
    await GetPatientTreatmentsNotes()
  }

  const historyTypeMapping = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const getPersonalHistoryData = async () => {
    if (!hasValidPatientContext) {
      setHistories({
        pmhx: [],
        pshx: [],
        fh: [],
        sh: [],
      })
      return {}
    }

    let newHistories = {}

    // Loop through all history types
    for (const [key, historyType] of Object.entries(historyTypeMapping)) {
      try {
        const allData = await getPatientPersonalHistory('GET', patientID, historyType, '')
        const formattedData = JSON.parse(allData?.d)

        if (formattedData && formattedData.Data) {
          newHistories[key] = formattedData.Data
        }
      } catch (error) {
        console.error(`Error fetching ${historyType}:`, error)
        // You could optionally add fallback or error info to newHistories[key] = ...
      }
    }

    // Update all histories at once
    setHistories((prevHistories) => ({
      ...prevHistories,
      ...newHistories,
    }))

    return newHistories
  }

  useEffect(() => {
    carryForwardData()
  }, [creatingNewNote])

  // useEffect(() => {
  //     showOnlyNoteDiagnosis()
  // }, [noteStructureRef.current?.metadata])

  // useEffect(() => {
  //   showOnlyNoteDiagnosis()
  // }, [diagnosisAddedPinger])

  const handleOrderFlag = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      orderFlag: false,
    }
    setShowOrderPopUp(false)
  }

  const addDiagnosisIdsToNote = async (ids) => {
    if (ids.length > 0) {
      const allDiagnosisNames = ids
        .map((id) => {
          const diagnosis = MasterDiagnosisData.find((d) => d.id === id)
          return diagnosis ? diagnosis.Name.trim() : null
        })
        .filter(Boolean)

      setPatientData({
        ...patientData,
        Diagnosis: [...new Set([...(patientData.Diagnosis?.split(',') || []), ...allDiagnosisNames])].join(', '),
      })
    }

    const existingIds = noteStructureRef.current.metadata?.diagnosisIds || []
    const combinedIds = [...existingIds, ...ids]
    const uniqueIds = Array.from(new Set(combinedIds))

    noteStructureRef.current = {
      ...noteStructureRef.current,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: uniqueIds,
      },
    }
    await saveTreatsShell(false)
    // localStorage.setItem('patientDataUpdated', Date.now()) //u can used to update the patient data liseting as event listener of storaage
  }

  const fetchAddendumData = async () => {
    if (!hasValidNoteContext) {
      setAddendum(null)
      return null
    }

    try {
      let data = await SaveExtra('Get_By_Type', 'Addendum', '', '')

      data = JSON.parse(data?.d)?.Data || []

      data = data.map((item) => JSON.parse(item?.JsonData))
      data = data.reverse() // latest first

      const currentNoteID = noteID?.toString()
      const noteIDNum = parseInt(noteID, 10)
      const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null

      const findPatientNoteData = (data, patientID, noteID) => {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]

          if (item[patientID]) {
            if (item[patientID][currentNoteID]) {
              return item[patientID][currentNoteID]
            }

            if (previousNoteID && item[patientID][previousNoteID]) {
              return item[patientID][previousNoteID]
            }
          }
        }
        return null
      }

      const result = findPatientNoteData(data, patientID, noteID)
      if (result) {
        setAddendum(result)
        return result
      } else {
        const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID
        console.warn(`Patient ${patientID} with note ${searchNotes} not found`)
        setAddendum(null)
      }
    } catch (error) {
      console.error('Failed to fetch addendum data:', error)
      setAddendum(null)
    }
    return null
  }

  // set all diagnosis or anything for quick in note structure
  // useEffect(()=>{
  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     metadata: {
  //       ...noteStructureRef.current.metadata,
  //       diagnosisIds :[97, 40, 56, 66, 88, 141, 85, 55, 142, 67, 65, 48, 90, 45, 68, 100, 113, 58, 150, 115, 51, 27, 71, 21, 127, 89, 95, 99, 91, 75, 101, 123, 23, 62, 139, 41, 63, 43, 103, 143, 140, 86, 87, 92, 125, 25, 64, 148, 108, 70, 107, 37, 34, 128, 93, 35, 105, 36, 42, 59, 50, 130, 74, 53, 116, 77, 39, 61, 20, 129, 117, 46, 69, 49, 124, 24, 126, 26, 52, 47, 112, 114, 109, 149, 38, 72, 132, 133, 131, 110, 134, 54, 144, 146, 145, 76, 106]
  //     }
  //   }
  //   saveTreatsShell(false)
  // },[])

  const fetchPastOrders = async () => {
    if (!hasValidNoteContext) {
      setPastOrders([])
      setShowOrderPopUpYN(false)
      return []
    }

    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []

      const parsedOrders = data
        ?.map((order) => ({
          // ...order,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

      setPastOrders(parsedOrders)

      setShowOrderPopUpYN(parsedOrders?.length === 0 ? false : true)
      return parsedOrders
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
    return []
  }

  const setPatientDiagnois = async (diagnosisJoined) => {
    let patientAllData = await patientSelected(patientData)
    await ModifyPatientMap('UPDATE', patientID, diagnosisJoined, patientAllData?.value)
  }

  const removeDiagnosisIdFromNote = async (diagnosiNameToRemove) => {
    setRowClicked((p) => {
      const diagnosisArray = p?.Diagnosis ? p?.Diagnosis.split(',').map((item) => item.trim()) : []

      const updatedDiagnosisArray = diagnosisArray.filter((item) => item !== diagnosiNameToRemove)

      return {
        ...p,
        Diagnosis: updatedDiagnosisArray.join(', '),
      }
    })

    // Fetch all diagnosis list
    let allDiagnosis = await GetDiagnosisData('')
    allDiagnosis = JSON.parse(allDiagnosis.d)?.Data

    // Filter from local patientDiagnosis list
    const filterPatientDiagnosis = patientDiagnosis.filter((item) => item !== diagnosiNameToRemove)

    setPatientDiagnosis(filterPatientDiagnosis)

    // Get idToRemove from name
    const idToRemove = allDiagnosis.find((item) => item.Name === diagnosiNameToRemove)?.id

    // Check and update metadata in noteStructureRef
    const existingIds = noteStructureRef.current.metadata?.diagnosisIds || []

    const updatedIds = existingIds.filter((id) => id !== idToRemove)

    await setPatientDiagnosis(filterPatientDiagnosis.join(','))

    noteStructureRef.current = {
      ...noteStructureRef.current,
      metadata: {
        ...noteStructureRef.current.metadata,
        diagnosisIds: updatedIds,
      },
    }

    await saveTreatsShell(false)

    await getPatientDiagnosis()

    await showOnlyNoteDiagnosis()
  }
  useEffect(() => {
    showOnlyNoteDiagnosis()
  }, [diagnosisAddedPinger])

  // setting any patient diagnosis to empty
  // useEffect(()=>{

  //   const setPatientDiagnois = async () => {
  //     let patientAllData = await patientSelected(patientData)
  //   console.log("patientAllData", patientAllData)
  //   await ModifyPatientMap("UPDATE", patientID, "", patientAllData?.value)
  //   }
  //   setPatientDiagnois()
  // },[])
  const pathname = window.location.pathname // e.g. "/home/provider/completed-appointment"
  const segments = pathname.split('/').filter(Boolean) // removes empty strings

  // Join the first 3 segments
  const baseRoute = segments.slice(0, 3).join('/')

  const UpdateCheckForStatusData = async (update) => {
    let appointmentDetails = []
    if (appointments.length === 0) {
      appointmentDetails = await getAllAppointmentsDetails('GET')
    } else {
      appointmentDetails = appointments
    }
    let filterPatient = appointmentDetails && appointmentDetails.length > 0 && appointmentDetails.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled'))
    console.log("filterPatient", filterPatient)

    if (filterPatient.length > 0) {
      const selectedDate = convertDate(filterPatient[0]?.data?.StartTime)
      console.log("selected Data", selectedDate)
      const isDataFound = await checkIfDataAvailableData(selectedDate)
      if (isDataFound && Object.keys(isDataFound).length > 0 && filterPatient.length > 0) {

        const appointmentsData = filterPatient[0]
        updatePatientData({ existingPatientData: isDataFound?.JsonData, providerId: appointmentsData?.current?.Provider.value, patientId: appointmentsData?.current?.Patient?.value, updates: update, id: isDataFound?.Id, date: selectedDate })

      }
    }
  }

  const syncDiagnosisUpdate = async ({ diagnosisIds, diagnosisLabels }) => {
    // 1. Update backend FIRST
    await ModifyPatientMap('UPDATE', patientID, diagnosisLabels)

    // 2. Update note metadatas
    await addDiagnosisIdsToNote(diagnosisIds)

    // 3. Force-sync note diagnosis UI
    await showOnlyNoteDiagnosis()

    // 4. Refresh patient diagnosis state
    await getPatientDiagnosis()
  }

  return (
    <>
      {isPatientPageLoading ? (
        <div data-theme={theme} className="appointment-patient-info-theme" style={{ height: '100vh', background: 'var(--ui-dashboard-bg, #040404)', width: '100%' }}>
          <Loader />
        </div>
      ) : !patientData ? (
        <div data-theme={theme} className="appointment-patient-info-theme" style={{ height: '100vh', background: 'var(--ui-dashboard-bg, #040404)', width: '100%' }}>
          <Loader />
        </div>
      ) : (
        <div data-theme={theme} className="patient-info-page appointment-patient-info-theme">
          <div className="mb-3">
            <CBreadcrumb hidden={showBreadcrumbs}>
              {/* <CBreadcrumbItem href={baseRoute === 'home/provider/completed-appointment' ? '/home/provider/completed-appointment' ? baseRoute === '/home/provider/appointment' ? "/home/provider/appointment" : baseRoute === 'home/provider/all-patients' ? '/home/provider/all-patients' : baseRoute === 'home/all-appointment' ? '/home/all-appointment' : '/home/appointment'}> */}
              <CBreadcrumbItem
                href={
                  baseRoute === 'home/provider/completed-appointment'
                    ? '/home/provider/completed-appointment'
                    : baseRoute === 'home/provider/appointment'
                      ? '/home/provider/appointment'
                      : baseRoute === 'home/provider/all-patients'
                        ? '/home/provider/all-patients'
                        : baseRoute === 'home/all-appointment'
                          ? '/home/all-appointment'
                          : '/home/appointment'
                }
              >
                {baseRoute === 'home/provider/completed-appointment'
                  ? 'Completed Appointment'
                  : baseRoute === 'home/provider/pending-appointment'
                    ? 'Pending Appointment'
                    : baseRoute === 'home/provider/appointment'
                      ? 'Provider Appointment'
                      : baseRoute === 'home/provider/all-patients'
                        ? 'All Patients'
                        : 'Appointment'}
              </CBreadcrumbItem>
              <CBreadcrumbItem active>Patient Info</CBreadcrumbItem>
            </CBreadcrumb>
          </div>
          {showAllData && (
            <CRow className="gap-4">
              <div className="d-flex gap-4">
                <CCol xs="1" className="" style={{ width: '12.666667%' }}>
                  <div style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }} className="custom-no-scroll">
                    <CNav vertical type className="flex-column" variant="pills">
                      {navLinks.map((link, index) => (
                        <CNavItem key={index} className="mb-3">
                          <CNavLink active={activeTab === link.tab} onClick={() => handleTabClick(link.tab)} href="#">
                            {link.title}
                          </CNavLink>
                        </CNavItem>
                      ))}
                    </CNav>
                  </div>
                </CCol>

                <PatientFloatingButton
                  addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                  handleToggleAddDiagnosis={() => {
                    setAddDiagnosisModalVisible((p) => !p)
                  }}
                  targetRef={targetRef}
                  toPDF={toPDF}
                  noteStructureRef={noteStructureRef}
                  saveTreatsShell={handleSaveModule}
                  submitTreatsShell={submitTreatsShell}
                  setNoteView={setNoteView}
                />

                <CCol xs={10} className="" style={{ height: '100vh' }}>
                  <CRow className="mb-3">
                    <CCard style={{ borderRadius: '10px', height: '90vh', overflow: 'auto' }}>
                      <CCardBody>
                        <div style={{ height: '100%', overflowY: 'auto' }}>
                          {activeTab === 0 && (
                            <div className="position-relative">
                              <ShowDemographics formData={patientData}
                                loading={loading}
                                setLoading={setLoading}
                                diagnosis={diagnosisData} patientDiagnosis={patientDiagnosis} diagnosisData={diagnosisData}></ShowDemographics>
                            </div>
                          )}
                          {activeTab === 1 && (
                            <div className="position-relative">
                              <Summary setActiveTab={setActiveTab} vitalsList={vitalsList} patientData={patientData} />
                            </div>
                          )}
                          {activeTab === 2 && (
                            <div className="position-relative">
                              <PatientHistoryForm
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                allHistory={allHistory}
                                setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                                getHistory={getHistory}
                                setAllHistory={setAllHistory}
                                patientID={patientID}
                                loading={loading}
                                setLoading={setLoading}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                                saveTreatsShellForHospitalRecord={saveTreatsShellForHospitalRecord}
                                appointments={appointments}
                                UpdateCheckForStatusData={UpdateCheckForStatusData}
                              ></PatientHistoryForm>
                            </div>
                          )}
                          {activeTab === 3 && (
                            <div className="position-relative">
                              <PatientPersonalHistory
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                                activeTab={historyPersonalHistoryActiveTab}
                                setActiveTab={setHistoryPersonalHistoryActiveTab}
                                patientID={patientID}
                                histories={histories}
                                setHistories={setHistories}
                                loading={loading}
                                setLoading={setLoading}
                                Notes={Notes}
                                setNotes={setNotes}
                                noteStructureRef={noteStructureRef}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientPersonalHistory>
                            </div>
                          )}
                          {activeTab === 18 && (
                            <div className="position-relative">
                              <Addendum patientID={patientID} noteID={noteID} />
                            </div>
                          )}
                          {activeTab === 4 && (
                            <div className="position-relative">
                              <PatientInternalNotes noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} Notes={Notes} setNotes={setNotes}></PatientInternalNotes>
                            </div>
                          )}
                          {activeTab === 5 && (
                            <div className="position-relative">
                              <PatientVitals noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} vitalsList={vitalsList} setVitalsList={setVitalsList}></PatientVitals>
                            </div>
                          )}
                          {activeTab === 8 && (
                            <div className="position-relative">
                              <PatientMedication
                                saveTreatsShell={saveTreatsShell}
                                noteID={noteID}
                                setNewmedsAdded={setNewmedsAdded}
                                patientID={patientID}
                                patientName={[patientData?.FirstName, patientData?.MiddleName, patientData?.LastName].filter(Boolean).join(' ')}
                                facilityName={patientData?.FacilityName || ''}
                                roomNumber={patientData?.Room || ''}
                                fetchMedications={fetchMedications}
                                loading={loading}
                                setLoading={setLoading}
                                medicationList={medicationList}
                                setMedicationList={setMedicationList}
                                noteStructureRef={noteStructureRef}
                                appoinmentDate={appoinmentDate}
                              ></PatientMedication>
                            </div>
                          )}
                          {activeTab === 13 && (
                            <div className="position-relative">
                              <PatientAllergies noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} allergiesList={allergiesList} setAllergiesList={setAllergiesList}></PatientAllergies>
                            </div>
                          )}
                          {activeTab === 16 && (
                            <div className="position-relative">
                              <Reports patientID={patientID} />
                            </div>
                          )}
                          {activeTab === 6 && (
                            <div className="position-relative">
                              <PatientImaging
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                setNewImagingAdded={setNewImagingAdded}
                                GetPatientImagings={GetPatientImagings}
                                setRender={refreshImagingSection}
                                patientID={patientID}
                                setImagingList={setImagingList}
                                imagingTypeList={imagingTypeList}
                                loading={loading}
                                setLoading={setLoading}
                                imagingList={imagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                setShowComment={setShowComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientImaging>
                            </div>
                          )}
                          {activeTab === 9 && (
                            <div className="position-relative">
                              <PastOrder patientID={patientID} noteID={noteID} orders={pastOrders} noteStructureRef={noteStructureRef} />
                            </div>
                          )}
                          {activeTab === 15 && <div className="position-relative">{/* <PatientOrder patientID={patientID} fetchOrders={fetchOrders} patientOrders={patientOrders} setPatientOrders={setPatientOrders} /> */}</div>}
                          {activeTab === 10 && (
                            <div className="position-relative">
                              <Note
                                vitalsList={vitalsList}
                                isAllotedToProvider={isAllotedToProvider}
                                saveTreatsShell={saveTreatsShell}
                                setDataId={setDataId}
                                statusPatientNote={noteStatus || ''}
                                showComment={showComment}
                                targetRef={targetRef}
                                selectedRisks={selectedRisks}
                                setSelectedRisks={setSelectedRisks}
                                selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                                setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                                toPDF={toPDF}
                                masterMedications={masterMedications}
                                setMasterMedications={setMasterMedications}
                                GetMasterMedications={GetMasterMedications}
                                noteStructureRef={noteStructureRef}
                                hospitalRecords={allHistory}
                                setHospitalRecords={setAllHistory}
                                medication={medicationList}
                                setMedication={setMedicationList}
                                patientID={patientID}
                                diagnosisAddedPinger={diagnosisAddedPinger}
                                allergies={allergiesList}
                                setAllergies={setAllergiesList}
                                MasterDiagnosisData={MasterDiagnosisData}
                                imaging={imagingList}
                                setImaging={setImagingList}
                                newImagingAdded={newImagingAdded}
                                newLabsAdded={newLabsAdded}
                                newmedsAdded={newmedsAdded}
                                activeTab={historyPersonalHistoryActiveTab}
                                setActiveTab={setHistoryPersonalHistoryActiveTab}
                                patientData={patientData}
                                patientSidebarActiveTab={activeTab}
                                diagnosisCode={diagnosisCode}
                                patientTreatments={patientTreatments}
                                personalHistory={histories}
                                setPersonalHistory={setHistories}
                                allLabs={allLabs}
                                setReRender={setReRender}
                                patientDiagnosis={patientDiagnosis}
                                loading={loading}
                                imagingTypeList={imagingTypeList}
                                setLoading={setLoading}
                                imagingList={imagingList}
                                setImagingList={setImagingList}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                noteID={noteID}
                                editPatientDiagnosis={editPatientDiagnosis}
                                deletePatientDiagnosis={deletePatientDiagnosis}
                                updateNoteStructure={updateNoteStructure}
                                setUpdatePE={setUpdatePE}
                                updatePE={updatePE}
                                saveTreatsShellForHospitalRecord={saveTreatsShellForHospitalRecord}
                                appointments={appointments}
                                UpdateCheckForStatusData={UpdateCheckForStatusData}
                              ></Note>
                            </div>
                          )}
                          {activeTab === 7 && (
                            <div className="position-relative">
                              <PatientLabs
                                removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                                saveTreatsShell={saveTreatsShell}
                                fetchPatientLabs={fetchPatientLabs}
                                setDataId={setDataId}
                                setNewLabsAdded={setNewLabsAdded}
                                updatePatientDiagnosis={updatePatientDiagnosis}
                                diagnosis={patientDiagnosis}
                                patientID={patientID}
                                allLabs={allLabs}
                                setAllLabs={setAllLabs}
                                loading={loading}
                                setLoading={setLoading}
                                noteStructureRef={noteStructureRef}
                                showComment={showComment}
                                addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                              ></PatientLabs>
                            </div>
                          )}
                          {activeTab === 20 && (
                            <div className="position-relative">
                              <PatientPastNoteAdmin providerCall={false} viewPatientDetail={patientData} patientTreatments={patientTreatments} noteID={noteID} />
                            </div>
                          )}

                          {activeTab === 17 && (
                            <div className="position-relative">
                              <PatientPsychiatryNote loading={loading} patientID={patientID} noteStructureRef={noteStructureRef}
                                setLoading={setLoading} diagnosis={patientDiagnosis} />
                            </div>
                          )}

                          {/* {activeTab === 17 && (
                            <div className="position-relative">
                              <HPIQuestions diagnosis={patientDiagnosis} />
                            </div>
                          )} */}
                        </div>
                      </CCardBody>
                    </CCard>
                  </CRow>
                </CCol>
                <CModal className="appointment-submit-modal" size="xl" visible={modalVisible} backdrop={'static'} keyboard={false} onClose={() => setModalVisible(false)}>
                  <CModalHeader onClose={() => setModalVisible(false)}>
                    <CModalTitle>Note Details</CModalTitle>
                  </CModalHeader>
                  <CModalBody  >
                    <DetailNote
                      setSubmitLoader={setSubmitLoader}
                      submitLoader={submitLoader}
                      isAllotedToProvider={isAllotedToProvider}
                      statusPatientNote={noteStatus && noteStatus === 'Follow Up' ? true : false}
                      handleSubmitModule={handleSubmitModule}
                      showHrsInTreatment={true}
                      showTreatmentAsAccordion={true}
                      showComment={showComment}
                      submitNotes={submitNotes}
                      setModalVisible={setModalVisible}
                      formData={patientData}
                      diagnosis={diagnosisData}
                      diagnosisCode={diagnosisCode}
                      noteStructureRef={noteStructureRef}
                      selectedRisks={selectedRisks}
                      setSelectedRisks={setSelectedRisks}
                      selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                      setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                      hospitalRecords={allHistory}
                      setHospitalRecords={setAllHistory}
                      medication={medicationList}
                      setMedication={setMedicationList}
                      patientID={patientID}
                      patientTreatments={patientTreatments}
                      newImagingAdded={newImagingAdded}
                      newLabsAdded={newLabsAdded}
                      newmedsAdded={newmedsAdded}
                      diagnosisAddedPinger={diagnosisAddedPinger}
                      allergies={allergiesList}
                      setAllergies={setAllergiesList}
                      patientDiagnosis={patientDiagnosis}
                      MasterDiagnosisData={MasterDiagnosisData}
                      imagingTypeList={imagingTypeList}
                      imaging={imagingList}
                      setImaging={setImagingList}
                      activeTab={historyPersonalHistoryActiveTab}
                      setActiveTab={setHistoryPersonalHistoryActiveTab}
                      patientData={patientData}
                      patientSidebarActiveTab={activeTab}
                      personalHistory={histories}
                      setPersonalHistory={setHistories}
                      allLabs={allLabs}
                      noteID={noteID}
                      showMedicationLikeApp={true}
                      noteStatus={noteStatus}
                      setDataId={setDataId}
                      addendum={addendum}
                    />
                  </CModalBody>
                </CModal>

                {/* <CCol xs={3} className='custom-scrollbar-container border  bg-white  ' style={{
                    overflowX: "hidden",
                    overflowY: "auto",
                    borderRadius: '10px',
                    // paddingRight: '8px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#c0c0c0 transparent',
                    height: '90vh'
                  }}>
                    <div className=' '>
                      <PatientFinalNote
                        statusPatientNote={noteStatus && noteStatus === "Follow Up" ? true : false}
                        diagnosisCode={diagnosisCode}
                        noteStructureRef={noteStructureRef}
                        selectedRisks={selectedRisks} setSelectedRisks={setSelectedRisks}
                        selectedDifferentialDiagnosis={selectedDifferentialDiagnosis} setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                        hospitalRecords={allHistory} setHospitalRecords={setAllHistory}
                        medication={medicationList} setMedication={setMedicationList}
                        patientID={patientID}
                        patientTreatments={patientTreatments}
                        newImagingAdded={newImagingAdded} newLabsAdded={newLabsAdded} newmedsAdded={newmedsAdded}
                        diagnosisAddedPinger={diagnosisAddedPinger}
                        allergies={allergiesList} setAllergies={setAllergiesList}
                        patientDiagnosis={patientDiagnosis}
                        MasterDiagnosisData={MasterDiagnosisData}
                        imagingTypeList={imagingTypeList}
                        imaging={imagingList} setImaging={setImagingList}
                        activeTab={historyPersonalHistoryActiveTab} setActiveTab={setHistoryPersonalHistoryActiveTab}
                        patientData={patientData} patientSidebarActiveTab={activeTab}
                        personalHistory={histories} setPersonalHistory={setHistories}
                        allLabs={allLabs}
                        noteShow={true} noteID={noteID}
                      ></PatientFinalNote>
                     
                    </div>
                  </CCol> */}
              </div>
              <div>
                <CModal size="xl" backdrop="static" visible={noteView} onClose={() => setNoteView(false)}>
                  <CModalHeader onClose={() => setNoteView(false)}>
                    <CModalTitle className="text-center w-100">Patient Note</CModalTitle>
                  </CModalHeader>
                  <CModalBody
                    style={{
                      height: '80vh',
                      overflowY: 'auto', // optional: adds scroll if content exceeds height
                    }}
                  >
                    <SuperBill
                      patientID={patientID}
                      statusPatientNote={noteStatus || ''}
                      showHrsInTreatment={true}
                      setDataId={setDataId}
                      showTreatmentAsAccordion={true}
                      showComment={showComment}
                      submitNotes={submitNotes}
                      setModalVisible={setModalVisible}
                      formData={patientData}
                      diagnosis={diagnosisData}
                      diagnosisCode={diagnosisCode}
                      noteStructureRef={noteStructureRef}
                      selectedRisks={selectedRisks}
                      setSelectedRisks={setSelectedRisks}
                      selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                      setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                      hospitalRecords={allHistory}
                      setHospitalRecords={setAllHistory}
                      medication={medicationList}
                      setMedication={setMedicationList}
                      patientTreatments={patientTreatments}
                      newImagingAdded={newImagingAdded}
                      newLabsAdded={newLabsAdded}
                      newmedsAdded={newmedsAdded}
                      diagnosisAddedPinger={diagnosisAddedPinger}
                      allergies={allergiesList}
                      setAllergies={setAllergiesList}
                      patientDiagnosis={patientDiagnosis}
                      MasterDiagnosisData={MasterDiagnosisData}
                      imagingTypeList={imagingTypeList}
                      imaging={imagingList}
                      setImaging={setImagingList}
                      activeTab={historyPersonalHistoryActiveTab}
                      setActiveTab={setHistoryPersonalHistoryActiveTab}
                      patientData={patientData}
                      patientSidebarActiveTab={activeTab}
                      personalHistory={histories}
                      setPersonalHistory={setHistories}
                      allLabs={allLabs}
                      noteID={noteID}
                      showMedicationLikeApp={true}
                    />
                  </CModalBody>
                </CModal>
                <AddPatientDiagnosisModal
                  showOnlyNoteDiagnosis={showOnlyNoteDiagnosis}
                  setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                  addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                  saveDiagnosisData={saveDiagnosisData}
                  patientData={patientData}
                  setAddDiagnosisModalVisible={setAddDiagnosisModalVisible}
                  addDiagnosisModalVisible={addDiagnosisModalVisible}
                  handleToggleAddDiagnosis={() => {
                    setAddDiagnosisModalVisible((p) => !p)
                  }}
                  noteStructureRef={noteStructureRef}
                  patientID={patientID}
                  getPatientDiagnosis={getPatientDiagnosis}
                  updatePatientDiagnosis={updatePatientDiagnosis}
                  patientDiagnosis={patientDiagnosis}
                  syncDiagnosisUpdate={syncDiagnosisUpdate}
                  saveTreatsShell={saveTreatsShell}
                />

                <CModal size="md" backdrop="static" visible={showSaveModel} onClose={() => setShowSaveModel(false)}>
                  <CModalHeader>
                    <CModalTitle>Warning</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                    <p>This note has already been submitted. Are you sure you want to save it as a draft?</p>
                  </CModalBody>

                  <CModalFooter>
                    <CButton
                      onClick={() => {
                        ; (saveTreatsShell(), setShowSaveModel(false))
                      }}
                      variant="outline"
                      color="warning"
                    >
                      Save as Draft
                    </CButton>
                    <CButton
                      onClick={() => {
                        setShowSaveModel(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>

                <CModal size="md" backdrop="static" visible={signModel} onClose={() => setSignModel(false)}>
                  <CModalHeader>
                    <CModalTitle>Warning</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                    <p>This note has already been Signed. Are you sure you want to save it as a submit?</p>
                  </CModalBody>

                  <CModalFooter>
                    <CButton
                      onClick={() => {
                        ; (submitNotes(), setSignModel(false))
                      }}
                      variant="outline"
                      color="warning"
                    >
                      Save as Submit
                    </CButton>
                    <CButton
                      onClick={() => {
                        setSignModel(false)
                      }}
                      className=" "
                      variant="outline"
                      color="secondary"
                    >
                      {' '}
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>
              </div>

              {showOrderPopUpYN && (
                <CModal 
                  size="lg" 
                  backdrop="static" 
                  visible={showOrderPopUp} 
                  onClose={() => setShowOrderPopUp(false)}
                  className="dashboard-dark-modal patient-theme-modal patient-theme-modal--previous-order"
                >
                  <CModalHeader>
                    <CModalTitle>Previous Order</CModalTitle>
                  </CModalHeader>
                  <CModalBody
                    className="patient-theme-modal-body patient-theme-modal-body--previous-order"
                    style={{ maxHeight: '70vh', overflowY: 'auto', overflowX: 'hidden', minHeight: 0 }}
                  >
                    <PastOrder patientID={patientID} noteID={noteID} headerShow={false} orders={pastOrders} noteStructureRef={noteStructureRef} />
                  </CModalBody>

                  <CModalFooter className="mt-2">
                    <CButton 
                      onClick={() => handleOrderFlag()}
                      style={{
                        backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
                        borderColor: 'var(--ui-color-primary, #2b7cd3)',
                        color: 'white',
                        fontWeight: '600'
                      }}
                    >
                      Verified
                    </CButton>
                    <CButton
                      onClick={() => {
                        setShowOrderPopUp(false)
                      }}
                      color="secondary"
                      style={{
                        marginLeft: '10px'
                      }}
                    >
                      Cancel
                    </CButton>
                  </CModalFooter>
                </CModal>
              )}
            </CRow>
          )}
          {showNoteView && patientTreatments && (
            <>
              <PatientNoteViewInModal
                patientID={patientID}
                statusPatientNoteWasFollowUp={noteStatus && noteStatus === 'Follow Up' ? true : false}
                showHrsInTreatment={true}
                setDataId={setDataId}
                setRowClicked={setRowClicked}
                showTreatmentAsAccordion={true}
                setAppointmentDetails={setAppointmentDetails}
                showComment={showComment}
                submitNotes={submitNotes}
                setModalVisible={setModalVisible}
                formData={patientData}
                diagnosis={diagnosisData}
                diagnosisCode={diagnosisCode}
                noteStructureRef={noteStructureRef}
                selectedRisks={selectedRisks}
                setSelectedRisks={setSelectedRisks}
                selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                hospitalRecords={allHistory}
                setHospitalRecords={setAllHistory}
                medication={medicationList}
                setMedication={setMedicationList}
                patientTreatments={patientTreatments}
                newImagingAdded={newImagingAdded}
                newLabsAdded={newLabsAdded}
                newmedsAdded={newmedsAdded}
                diagnosisAddedPinger={diagnosisAddedPinger}
                allergies={allergiesList}
                setAllergies={setAllergiesList}
                patientDiagnosis={patientDiagnosis}
                MasterDiagnosisData={MasterDiagnosisData}
                imagingTypeList={imagingTypeList}
                imaging={imagingList}
                setImaging={setImagingList}
                activeTab={historyPersonalHistoryActiveTab}
                setActiveTab={setHistoryPersonalHistoryActiveTab}
                patientData={patientData}
                patientSidebarActiveTab={activeTab}
                personalHistory={histories}
                setPersonalHistory={setHistories}
                allLabs={allLabs}
                noteID={noteID}
                showMedicationLikeApp={true}
                showToolbar={true}
                addendumData={addendum}
                showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
              ></PatientNoteViewInModal>
            </>
          )}
        </div>
      )}
    </>
  )
}
export default PatientInfoSecond
